import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import Input from '../components/sprite-selector-item-input/sprite-selector-item-input.jsx';
/**
 * Higher Order Component to manage inputs that submit on blur and <enter>
 * @param {React.Component} Input text input that consumes onChange, onBlur, onKeyPress
 * @returns {React.Component} Buffered input that calls onSubmit on blur and <enter>
 */

class spriteSelectorItemInput extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChange',
            'handleKeyPress',
            'handleFlush'
        ]);
        this.textInput = null;
        this.setTextInutRef = element => {
            this.textInput = element;
        };
        this.state = {
            value: null
        };
    }

    componentDidMount () {
        if (this.textInput) this.textInput.focus();
    }
    handleKeyPress (e) {
        if (e.key === 'Enter') {
            this.handleFlush();
            e.target.blur();
        }
    }
    handleFlush () {
        this.props.onExitEditMode();
        const isNumeric = typeof this.props.value === 'number';
        const validatesNumeric = isNumeric ? !isNaN(this.state.value) : true;
        if (this.state.value !== null && validatesNumeric) {
            this.props.onSubmit(isNumeric ? Number(this.state.value) : this.state.value);
        }
        this.setState({value: null});
    }
    handleChange (e) {
        this.setState({value: e.target.value});
    }
    render () {
        const bufferedValue = this.state.value === null ? this.props.value : this.state.value;
        return (
            <Input
                {...this.props}
                inputRef={this.setTextInutRef}
                value={bufferedValue}
                onBlur={this.handleFlush}
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
                
                
            />
        );
    }
}

spriteSelectorItemInput.propTypes = {
    onExitEditMode: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
   

export default spriteSelectorItemInput;
